export default {"src":"/_next/static/media/delivery.785beded.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};